import { immerable } from 'immer';

type FormulaType = 'value' | 'function';
interface IFormulaEntity {
	value: string;
	params: Array<FormulaEntity>;
	type: FormulaType;
}

const entityDefaults: IFormulaEntity = {
	value: '',
	params: [],
	type: 'value',
};

export class FormulaEntity implements IFormulaEntity {
	private [immerable] = true;
	public value = entityDefaults.value;
	public params = entityDefaults.params;
	public type = entityDefaults.type;

	public static build(params: Partial<IFormulaEntity> = {}): FormulaEntity {
		const entity = new FormulaEntity();
		entity.value = params.value ?? entityDefaults.value;
		entity.params = params.params ?? entityDefaults.params;
		entity.type = params.type ?? entityDefaults.type;
		return entity;
	}

	public getPreview(formula: FormulaEntity): string {
		if (formula.type === 'value') {
			return `'${formula.value}'`;
		}

		const paramsPreview = formula.params
			.map((param) => param.getPreview(param))
			.join(', ');
		return `${this.value}(${paramsPreview})`;
	}
}
